import { Typography } from "@mui/material";
import { SubscriptionType } from "schemas/dashboard";

import { formatEpochTimestamp } from "utils/time";

import { SubscriptionMessages } from "../helpers";
import styles from "../styles";

interface Props {
  status: SubscriptionType;
  cancelAt?: number;
  warningText?: string;
}
const SubscriptionStatusText = ({
  status,
  cancelAt,
  warningText = "",
}: Props) => {
  return (
    <Typography paragraph sx={styles.warningText}>
      {status && status in SubscriptionMessages && SubscriptionMessages[status]}
      {cancelAt && (
        <>
          Your subscription is set to cancel on{" "}
          <strong>
            {formatEpochTimestamp({
              epochTimestamp: cancelAt,
              addYear: true,
            })}
          </strong>
          . {warningText}
        </>
      )}
    </Typography>
  );
};

export default SubscriptionStatusText;
